import { getElement, getElements } from '../utils/functional'
import 'swiper/swiper.scss';
import { Swiper, Navigation, Pagination, Autoplay } from "swiper";

export const createContext = el => {
  const context = { context: el }
  
  return Object.freeze({
    className: el.dataset.moduleClass,
    getElement: selector => getElement(selector, context),
    getElements: selector => getElements(selector, context),
  })
}

export const initialiseCarousel = (container, config, swiperModules = []) => {
  const defaultConfig = {
    preloadImages: false,
    updateOnImagesReady: false,
    lazy: true,
    lazyLoadingInPrevNextAmount: 0,
    loop: true,
    speed: 500
  }
  const swiperConfig = Object.assign({}, defaultConfig, config)
  if(config.pagination !== false){
    Swiper.use(Pagination);
  }
  Swiper.use(Navigation);
  /* eslint-disable no-new */
  Swiper.use(Autoplay);
  return new Swiper(container, swiperConfig)
}

export const Listeners = {
  entries: [],

  add: function add (element, event, fn) {
    this.entries.push({ element, event, fn })

    element.addEventListener(event, fn)
  },

  remove: function remove (event, fn) {
    const foundListener = this.entries.find(
      listener => listener.event === event && listener.fn === fn
    )

    if (foundListener) {
      this.entries = this.entries.filter(listener => listener !== foundListener)

      foundListener.element.removeEventListener(
        foundListener.event,
        foundListener.fn
      )
    }
  },

  removeAll: function removeAll () {
    this.entries = this.entries.filter(listener => {
      listener.element.removeEventListener(listener.event, listener.fn)

      return false
    })
  },
}

export function ReactiveState (initialState) {
  this.internalState = {}

  if (!Object.entries) {
    Object.entries = function( obj ){
      var ownProps = Object.keys( obj ),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array
      while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      
      return resArray;
    };
  }

  Object.entries(initialState).forEach(([key, initialValue]) =>
    this.makeKeyReactive(key, initialValue)
  )
}

ReactiveState.prototype.getPrivateKey = function getPrivateKey (key) {
  return `_${key}`
}

ReactiveState.prototype.addKey = function makeKeyReactive (key, initialValue) {
  this.makeKeyReactive(key, initialValue)
}

ReactiveState.prototype.makeKeyReactive = function makeKeyReactive (
  key,
  initialValue
) {
  const _this = this
  const privateKey = this.getPrivateKey(key)

  this.internalState[privateKey] = {
    value: initialValue,
    listeners: [],
  }

  Object.defineProperty(this, key, {
    get () {
      return _this.internalState[privateKey]
    },
    set (val) {
      _this.notify(key, val, _this.internalState[privateKey].value)

      _this.internalState[privateKey].value = val
    },
  })

  return this.internalState
}

ReactiveState.prototype.subscribe = function subscribe (key, fnc) {
  if (this.checkIfKeyInState(key)) {
    const privateKey = this.getPrivateKey(key)

    this.internalState[privateKey].listeners.push(fnc)
  }
}

ReactiveState.prototype.unsubscribe = function unsubscribe (key, fnc) {
  if (this.checkIfKeyInState(key)) {
    const privateKey = this.getPrivateKey(key)

    /* prettier-ignore */
    this.internalState[privateKey].listeners = this.internalState[privateKey]
      .listeners.filter(fn => fn !== fnc)
  }
}

ReactiveState.prototype.notify = function notify (key, val, prevVal) {
  if (this.checkIfKeyInState(key)) {
    const privateKey = this.getPrivateKey(key)

    this.internalState[privateKey].listeners.forEach(fn => fn(val, prevVal))
  }
}

ReactiveState.prototype.checkIfKeyInState = function notify (
  key,
  throwError = true
) {
  const privateKey = this.getPrivateKey(key)
  const keyInState = privateKey in this.internalState

  if (keyInState === false && throwError) {
    throw new Error(`${key} doesn't exist in ObservableState`)
  }

  return keyInState
}